export { default as LawsuitListPage } from "./LawsuitListPage";
